<template>
  <BaseTableItemAction
    v-can:[showPermission]
    v-on="$listeners"
    v-bind="$attrs"
    icon="mdi-eye"
    actionName="عرض التفاصيل"
    :to="'/users/' + item.id"
  >
    <slot></slot>
  </BaseTableItemAction>
</template>

<script>
import { READ_USERS_PERMISSION } from "@/core/statics/Permissions";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      showPermission: READ_USERS_PERMISSION,
    };
  },
};
</script>
